/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

/**
 * Development Firebase project configuration for optimized development deployments.
 *
 * @constant {object} environment - Development environment configuration object
 * @property {boolean} production - Enables Angular production runtime behavior
 * @property {boolean} routeTracing - Enables route debugging and tracing
 * @property {boolean} useEmulators - Flag to use Firebase emulators for local development
 * @property {string} useEmulatedIp - IP address for emulator connections
 * @property {object} app - Application-specific configuration
 * @property {string} app.name - Application identifier for Firebase
 * @property {string} app.title - Human-readable application title
 * @property {string} app.defaultLanguage - Default locale for the application
 * @property {object} debug - Debug settings for development
 * @property {boolean} debug.ngrx - Enables NgRx state debugging
 * @property {boolean} debug.consolelogs - Controls console log output
 * @property {object} firebase - Firebase service configuration
 * @property {string} firebase.apiKey - Firebase API key for authentication
 * @property {string} firebase.authDomain - Firebase authentication domain
 * @property {string} firebase.databaseURL - Realtime database URL
 * @property {string} firebase.projectId - Firebase project identifier
 * @property {string} firebase.storageBucket - Cloud storage bucket name
 * @property {string} firebase.messagingSenderId - FCM sender ID
 * @property {string} firebase.appId - Firebase application identifier
 * @property {string} firebase.measurementId - Google Analytics measurement ID
 * @property {string} firebase.vapidKey - Web push notification key
 * @property {object} languageCodes - Locale code mappings
 * @property {string} languageCodes.en - English locale code
 * @property {string} languageCodes.es - Spanish (Puerto Rico) locale code
 * @property {Array<object>} languageList - Available language options
 * @property {object} loggerSettings - Application logging configuration
 * @property {boolean} loggerSettings.enabled - Master logging enable flag
 * @property {boolean} loggerSettings.enableDebugLogs - Debug level logging
 * @property {boolean} loggerSettings.enableInfoLogs - Info level logging
 * @property {boolean} loggerSettings.enableErrorLogs - Error level logging
 * @property {boolean} loggerSettings.enableExceptionLogs - Exception logging
 * @property {object} test - Testing environment settings
 * @property {boolean} test.testpage - Enables test page access
 * @property {object} mapbox - Mapbox integration configuration
 * @property {string} mapbox.accessToken - Mapbox API access token
 * @property {string} recaptchaSiteKey - Google reCAPTCHA site key
 */
import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  environmentName: 'development',
  production: true,
  routeTracing: false,
  useFirebaseEmulators: false,
  useEmulatedIp: '',
  app: {
    name: 'barberiaspr',
    title: 'Barberías PR',
    defaultLanguage: 'es-PR',
  },
  debug: {
    ngrx: true,
    consolelogs: true,
  },
  firebase: {
    apiKey: 'AIzaSyDD38ZJdwNq72NmzJCLB1kqT0fBmxN4kI0',
    authDomain: 'dev.barberiaspr.com',
    databaseURL: 'https://barberiaspr-dev-default-rtdb.firebaseio.com',
    projectId: 'barberiaspr-dev',
    storageBucket: 'barberiaspr-dev.firebasestorage.app',
    messagingSenderId: '249641240238',
    appId: '1:249641240238:web:23a4568a80c31ea2048f3f',
    measurementId: 'G-7WEDNNH6V3',
  },
  languageCodes: {
    en: 'en-US',
    es: 'es-PR',
  },
  languageList: [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
  ],
  loggerSettings: {
    enabled: true,
    enableDebugLogs: true,
    enableInfoLogs: true,
    enableErrorLogs: true,
    enableExceptionLogs: true,
  },
  test: {
    testpage: true,
  },
  mapbox: {
    accessToken: `pk.eyJ1IjoiZGp0dW1ib3ByIiwiYSI6ImNtM2FhdmhiYzFjZWwyaXB3MzBxa3NyZDMifQ.-lnnmS4J_smzPx4uk2kboQ`,
  },
  appCheck: {
    enabled: true,
    provider: 'recaptcha-enterprise',
    siteKey: '6LcgnfgtAAAAAH3kdKTekJqe8ySQFLNjlmyRl5Ld',
  },
  feature_overrides: {
    maintenance: {
      cd: 'cerquillobrutal',
      enabled: false,
    },
  },
  allowedOrigins: ['localhost:3007', '127.0.0.1:3007'],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
